import React from "react";
import PropTypes from "prop-types";
import {
  ReactPropsWithRequiredChildren,
  ReactComponentStaticProps,
} from "../../types/react";
import { CollapseProvider } from "./CollapseContext";

export type ComparisonTableCollapsibleProps = ReactPropsWithRequiredChildren;

export const ComparisonTableCollapsible: ((
  props: ComparisonTableCollapsibleProps
) => JSX.Element) &
  ReactComponentStaticProps<ComparisonTableCollapsibleProps> = ({
  children,
}) => {
  return <CollapseProvider>{children}</CollapseProvider>;
};

ComparisonTableCollapsible.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

ComparisonTableCollapsible.displayName = "ComparisonTable.Collapsible";

export default ComparisonTableCollapsible;
